import { useEffect, useState, forwardRef } from 'react';
import FooterNav from '../../components/dashboard/FooterNav';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import Main from '../../components/dashboard/Main';

import axios from  'axios';
import { Formik } from 'formik';

import jwtDecode from 'jwt-decode';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import styledComponent from "styled-components";
import { styled } from '@mui/material/styles';

import {
  Autocomplete,
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  FormControl,
  FormControlLabel,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Modal,
  InputAdornment,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  RadioGroup,
  Radio,
  SwipeableDrawer,
  Snackbar,
  Select,
  Stack,
  Paper,
  ListSubheader
} from "@mui/material";

import { blueGrey } from '@mui/material/colors';
import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

import PhoneInput from 'react-phone-input-2';

import {
  Search,
  Notifications,
  ShoppingCart,
  Email,
  LocalAtm,
  ExitToApp,
  PowerOffRounded
} from "@material-ui/icons";

import SearchIcon from '@mui/icons-material/Search';
import mainLogo from '../../assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';

import Countdown from 'react-countdown';
import NavbarTransaksi from '../../components/dashboard/NavbarTransaksi';
import FooterNavReadyStock from '../../components/dashboard/FooterNavReadyStock';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '60vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Completionist = () => {
    return (
        <span style={{ color: '#608cb3', fontWeight: '700', border: '1px solid rgb(233 140 140)', backgroundColor: '#ffd8d8', padding: '10px' }}>
            Waktu pembayaran telah habis
        </span>
    );
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      // Render a countdown
        return (
            <span style={{ color: '#ab2323', fontWeight: '700', border: '1px solid rgb(233 140 140)', backgroundColor: '#ffd8d8', padding: '10px' }}>
                {days} hari : {hours} jam : {minutes} menit : {seconds} detik
            </span>
        );
    }
};

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Wrapper = styledComponent.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const ReadyStockOrdered = ({ Cart, UpdatedCart }) => {

    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const [confirmingPayment, setConfirming] = useState(false);
    const [bankPayment, setBankPayment] = useState(false);
    const [escrowPayment, setEscrowPayment] = useState(false);
    const [mixPayment, setMixPayment] = useState(false);

    const handleClickAlert = () => {
      setOpenAlert(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const [cartState, setCartState] = useState([]);
    const [jmlState, setJmlState] = useState(0);
    const [totalState, setTotalState] = useState(0);

    const [isCheckedOut, setCheckedOut] = useState(false);
    const [token, setToken] = useState(
      JSON.parse(localStorage.getItem('token')) !== null ? 
          JSON.parse(localStorage.getItem('token')).token :
          null
    );

    const [orderData, setOrderData] = useState([]);
    const [pengirimanData, setPengirimanData] = useState([]);
    const [diskonMitra, setDiskonMitra] = useState(0);
    const [diskonMitraLabel, setDiskonMitraLabel] = useState(null);
    const [diskonKategori, setDiskonKategori] = useState([]);
    const [diskonKategoriTotal, setDiskonKategoriTotal] = useState([]);
    const [biayaDropship, setBiayaDropship] = useState(0);
    const [totalPayment, setTotalPayment] = useState(0);
    const [rekeningku, setRekeningku] = useState([]);
    const [rekeningFrom, setRekeningFrom] = useState(null);
    const [rekeningTo, setRekeningTo] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [jmlhtransfer, setJmlhtransfer] = useState(0);
    const [subTotalPayment, setSubTotalPayment] = useState(0);
    const [subTotalPaymentNormal, setSubTotalPaymentNormal] = useState(0);
    const [subTotalByJumlah, setSubTotalByJumlah] = useState(0);
    const [saldoData, setSaldoData] = useState(0);
    const [authData, setAuthData] = useState(null);

    const [mixJmlhtransfer, setMixJmlhtransfer] = useState(0);
    const [mixPakaiSaldo, setMixPakaiSaldo] = useState(0);
    const [mixRekeningFrom, setMixRekeningFrom] = useState(null);
    const [mixRekeningTo, setMixRekeningTo] = useState(null);

    const [openFormAlamat, setOpenFormAlamat] = useState(false);

    const [subdistricts, setSubdistricts] = useState([]);
    const [valueSubdistrict, setValueSubdistrict] = useState(subdistricts[0]);
    const [inputSdValue, setInputSdValue] = useState(null);
    const handleSelectSubdistrict = (e, val) => {
        setValueSubdistrict(val);
        setInputSdValue(val.subdistrict_id);
        if(selectedCourier !== null) {
          handleCourirChange(selectedCourier);
        }
    };
    
    const [isDropship, setIsDropship] = useState(null);
    const [telPengirim, setTelPengirim] = useState(null);
    const [telPenerima, setTelPenerima] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [selectedCourier, setCourier] = useState(null);

    const changeTelPengirim = (value) =>  {
        setTelPengirim(value);
    };

    const changeTelPenerima = (value) =>  {
        setTelPenerima(value);
    };

    const [cities, setCities] = useState([]);
    const [valueCity, setValueCity] = useState(cities[0]);
    const [inputCityValue, setInputCityValue] = useState(null);
    const handleSelectCity = async (e, val) => {
        setValueCity(val);
        setInputCityValue(val.city_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${val.city_id}`);
            setSubdistricts(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [provinces, setProvinces] = useState([]);
    const [valueProvince, setValueProvince] = useState(provinces[0]);
    const [inputProvValue, setInputProvValue] = useState(null);
    const handleSelectProvince = async (e, val) => {
        setValueProvince(val);
        setInputProvValue(val.province_id);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${val.province_id}`);
            setCities(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [beratPaket, setBerat] = useState(0);
    const [shippingCost, setShippingCost] = useState({});
    const [shippingLoading, setShippingLoading] = useState(false);

    const handleCourirChange = async (courierValue) => {
        const courierCode = courierValue.split('|');
        if( courierCode[0] === 'OR' ) {
          try {
            const getShipping = await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/cost`,
              {
                origin: 23,
                destination: inputSdValue,
                weight: beratPaket,
                courier: courierCode[1]
              },
              {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
              }
            );
            setShippingCost(getShipping.data.result.rajaongkir.results[0]);
            setShippingLoading(false);
    
          } catch (err) {
            console.log(err)
          }
        } else {
          setShippingLoading(false);
          setShippingCost({});
        }
    };
  
    const [layananState, setLayanan] = useState(null);

    const getRekeningku = async () => {
        try {
            const rekeningku = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/rekeningku`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
            });
            setRekeningku(rekeningku.data.result);
            
        } catch (err) {
            console.log(err);
        }
    };

    const getSaldo = async () => {
        try {
            const saldo = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/saldo`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
            });
            let debitData = 0;
            let creditData = 0;
            saldo.data.result.forEach((v) => {
                debitData += v.debit;
                creditData += v.credit;
            });
            setSaldoData(debitData - creditData);
        } catch (err) {
            console.log(err);
        }
    };

    const getOrder = async () => {
        try {
            const orderData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/detail-order/${searchParams.get('invoice')}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
            });
            let totalDiskonMitra = 0;
            let totalDiskonKategori = 0;
            let subtotalPayment = 0;
            const arrDiskonKategori = [];
            orderData.data.result.data.forEach((item) => {
                subtotalPayment += item.subtotal;
                totalDiskonMitra += item.subtotal_diskon_db;
                if (item.subtotal_diskon_kategori > 0 && item.subtotal_diskon_kategori_label !== '') {
                    arrDiskonKategori.push({
                        diskonKategoriLabel: item.subtotal_diskon_kategori_label,
                        diskonKategoriValue: item.subtotal_diskon_kategori
                    });
                    totalDiskonKategori += item.subtotal_diskon_kategori; 
                }
            });
            setSubTotalPayment(subtotalPayment);
            setDiskonKategori(arrDiskonKategori);
            setDiskonKategoriTotal(totalDiskonKategori);
            setDiskonMitra(totalDiskonMitra);
            setDiskonMitraLabel(orderData.data.result.diskon_label);
            setOrderData(orderData.data.result.data);
        } catch (err) {
            console.log(err);
        }
    };

    const getPengiriman = async () => {
        try {
            const getPengirimanData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/detail-shipping/${searchParams.get('invoice')}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
            });
            if(getPengirimanData.data.result !== null) {
                if (getPengirimanData.data.result.dropship === 'ya') {
                    if (parseInt(getPengirimanData.data.result.berat) <= 5000 && parseInt(getPengirimanData.data.result.berat) > 0) {
                        setBiayaDropship(3000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 10000 && parseInt(getPengirimanData.data.result.berat) > 5000) {
                        setBiayaDropship(5000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 20000 && parseInt(getPengirimanData.data.result.berat) > 10000) {
                        setBiayaDropship(10000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 30000 && parseInt(getPengirimanData.data.result.berat) > 20000) {
                        setBiayaDropship(15000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 40000 && parseInt(getPengirimanData.data.result.berat) > 30000) {
                        setBiayaDropship(20000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 50000 && parseInt(getPengirimanData.data.result.berat) > 40000) {
                        setBiayaDropship(25000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 60000 && parseInt(getPengirimanData.data.result.berat) > 50000) {
                        setBiayaDropship(30000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 70000 && parseInt(getPengirimanData.data.result.berat) > 60000) {
                        setBiayaDropship(35000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 80000 && parseInt(getPengirimanData.data.result.berat) > 70000) {
                        setBiayaDropship(40000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 90000 && parseInt(getPengirimanData.data.result.berat) > 80000) {
                        setBiayaDropship(45000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 100000 && parseInt(getPengirimanData.data.result.berat) > 90000) {
                        setBiayaDropship(50000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 110000 && parseInt(getPengirimanData.data.result.berat) > 100000) {
                        setBiayaDropship(55000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 120000 && parseInt(getPengirimanData.data.result.berat) > 110000) {
                        setBiayaDropship(60000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 130000 && parseInt(getPengirimanData.data.result.berat) > 120000) {
                        setBiayaDropship(65000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 140000 && parseInt(getPengirimanData.data.result.berat) > 130000) {
                        setBiayaDropship(70000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 150000 && parseInt(getPengirimanData.data.result.berat) > 140000) {
                        setBiayaDropship(75000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 160000 && parseInt(getPengirimanData.data.result.berat) > 150000) {
                        setBiayaDropship(80000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 170000 && parseInt(getPengirimanData.data.result.berat) > 160000) {
                        setBiayaDropship(85000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 180000 && parseInt(getPengirimanData.data.result.berat) > 170000) {
                        setBiayaDropship(90000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) <= 190000 && parseInt(getPengirimanData.data.result.berat) > 180000) {
                        setBiayaDropship(95000);
                    }
                    if (parseInt(getPengirimanData.data.result.berat) > 190000) {
                        setBiayaDropship(100000);
                    }
                }
                setPengirimanData(getPengirimanData.data.result);
            }
            
        } catch (err) {
            console.log(err);
        }
    };

    const handleCloseFormAlamat = () => {
        setOpenFormAlamat(false);
    };

    const [openModalRekening, setOpenModalRekening] = useState(false);

    const handleCloseModalRekening = () => setOpenModalRekening(false);
    const handleOpenModalRekening = () => setOpenModalRekening(true);

    useEffect(() => {

        const getAuth = async () => {
            try {
                const getAuthData = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                setAuthData(getAuthData.data.result);
                
            } catch (err) {
                console.log(err);
            }
        };

        const getRekeningku = async () => {
            try {
                const rekeningku = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/rekeningku`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                setRekeningku(rekeningku.data.result);
                
            } catch (err) {
                console.log(err);
            }
        };

        const getSaldo = async () => {
            try {
                const saldo = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/saldo`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                let debitData = 0;
                let creditData = 0;
                saldo.data.result.forEach((v) => {
                    debitData += v.debit;
                    creditData += v.credit;
                });
                setSaldoData(debitData - creditData);
            } catch (err) {
                console.log(err);
            }
        };

        const getOrder = async () => {
            try {
                const orderData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/detail-order/${searchParams.get('invoice')}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
                });
                let totalDiskonMitra = 0;
                let totalDiskonKategori = 0;
                let subtotalPayment = 0;
                let subtotalPaymentNormal = 0;
                let subtotalByJumlah = 0;
                const arrDiskonKategori = [];

                // if(new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date) {
                //   orderData.data.result.data.forEach((item) => {
                //     if(item.jenis === 'gamis' || item.jenis === 'koko') {
                //       subtotalPayment += 100000;
                //       subtotalByJumlah += (item.jumlah * 100000);
                //     } else {
                //       subtotalPayment += 50000;
                //       subtotalByJumlah += (item.jumlah * 50000);
                //     }
                //     subtotalPaymentNormal += item.subtotal;

                //     if(item.jenis === 'gamis' || item.jenis === 'koko') {
                //       totalDiskonMitra += (35/100 * (item.jumlah * 100000));
                //     } else {
                //       totalDiskonMitra += (35/100 * (item.jumlah * 50000));
                //     }

                //     if (item.subtotal_diskon_kategori > 0 && item.subtotal_diskon_kategori_label !== '') {
                //         arrDiskonKategori.push({
                //             diskonKategoriLabel: item.subtotal_diskon_kategori_label,
                //             diskonKategoriValue: item.subtotal_diskon_kategori
                //         });
                //         totalDiskonKategori += item.subtotal_diskon_kategori; 
                //     }
                //   });
                // } else {
                //   // normal price
                //   orderData.data.result.data.forEach((item) => {
                //     subtotalPayment += item.subtotal;
                //     totalDiskonMitra += item.idkategori === 1 ? item.subtotal_diskon_db : 0;
                //     console.log(item);
                //     if (item.subtotal_diskon_kategori > 0 && item.subtotal_diskon_kategori_label !== '') {
                //         arrDiskonKategori.push({
                //             diskonKategoriLabel: item.subtotal_diskon_kategori_label,
                //             diskonKategoriValue: item.subtotal_diskon_kategori
                //         });
                //         totalDiskonKategori += item.subtotal_diskon_kategori; 
                //     }
                //   });
                // }

                orderData.data.result.data.forEach((item) => {
                  subtotalPayment += item.subtotal;
                  totalDiskonMitra += item.idkategori === 1 ? item.subtotal_diskon_db : 0;
                  console.log(item);
                  if (item.subtotal_diskon_kategori > 0 && item.subtotal_diskon_kategori_label !== '') {
                      arrDiskonKategori.push({
                          diskonKategoriLabel: item.subtotal_diskon_kategori_label,
                          diskonKategoriValue: item.subtotal_diskon_kategori
                      });
                      totalDiskonKategori += item.subtotal_diskon_kategori; 
                  }
                });
                
                setSubTotalPayment(subtotalPayment);
                setSubTotalPaymentNormal(subtotalPaymentNormal);
                setSubTotalByJumlah(subtotalByJumlah);
                setDiskonKategori(arrDiskonKategori);
                setDiskonKategoriTotal(totalDiskonKategori);
                setDiskonMitra(totalDiskonMitra);
                setDiskonMitraLabel(orderData.data.result.diskon_label);
                setOrderData(orderData.data.result.data);
                console.log(totalDiskonMitra + totalDiskonKategori + (subTotalPaymentNormal - subTotalByJumlah));
            } catch (err) {
                console.log(err);
            }
        };

        const getPengiriman = async () => {
            try {
                const getPengirimanData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/detail-shipping/${searchParams.get('invoice')}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                if(getPengirimanData.data.result !== null) {
                    if (getPengirimanData.data.result.dropship === 'ya') {
                        if (parseInt(getPengirimanData.data.result.berat) <= 5000 && parseInt(getPengirimanData.data.result.berat) > 0) {
                            setBiayaDropship(3000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 10000 && parseInt(getPengirimanData.data.result.berat) > 5000) {
                            setBiayaDropship(5000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 20000 && parseInt(getPengirimanData.data.result.berat) > 10000) {
                            setBiayaDropship(10000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 30000 && parseInt(getPengirimanData.data.result.berat) > 20000) {
                            setBiayaDropship(15000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 40000 && parseInt(getPengirimanData.data.result.berat) > 30000) {
                            setBiayaDropship(20000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 50000 && parseInt(getPengirimanData.data.result.berat) > 40000) {
                            setBiayaDropship(25000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 60000 && parseInt(getPengirimanData.data.result.berat) > 50000) {
                            setBiayaDropship(30000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 70000 && parseInt(getPengirimanData.data.result.berat) > 60000) {
                            setBiayaDropship(35000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 80000 && parseInt(getPengirimanData.data.result.berat) > 70000) {
                            setBiayaDropship(40000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 90000 && parseInt(getPengirimanData.data.result.berat) > 80000) {
                            setBiayaDropship(45000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 100000 && parseInt(getPengirimanData.data.result.berat) > 90000) {
                            setBiayaDropship(50000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 110000 && parseInt(getPengirimanData.data.result.berat) > 100000) {
                            setBiayaDropship(55000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 120000 && parseInt(getPengirimanData.data.result.berat) > 110000) {
                            setBiayaDropship(60000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 130000 && parseInt(getPengirimanData.data.result.berat) > 120000) {
                            setBiayaDropship(65000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 140000 && parseInt(getPengirimanData.data.result.berat) > 130000) {
                            setBiayaDropship(70000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 150000 && parseInt(getPengirimanData.data.result.berat) > 140000) {
                            setBiayaDropship(75000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 160000 && parseInt(getPengirimanData.data.result.berat) > 150000) {
                            setBiayaDropship(80000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 170000 && parseInt(getPengirimanData.data.result.berat) > 160000) {
                            setBiayaDropship(85000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 180000 && parseInt(getPengirimanData.data.result.berat) > 170000) {
                            setBiayaDropship(90000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) <= 190000 && parseInt(getPengirimanData.data.result.berat) > 180000) {
                            setBiayaDropship(95000);
                        }
                        if (parseInt(getPengirimanData.data.result.berat) > 190000) {
                            setBiayaDropship(100000);
                        }
                    }
                    setPengirimanData(getPengirimanData.data.result);
                }
            } catch (err) {
                console.log(err);
            }
        };

        if(!verifyToken(token)){
            localStorage.removeItem('token');
            navigate('/');
        }

        getAuth();
        getRekeningku();
        getSaldo();
        getOrder();
        getPengiriman();

    }, []);

    return (
        <div>
            <NavbarTransaksi />
            <Container>
                <Modal
                    open={openFormAlamat}
                    onClose={handleCloseFormAlamat}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={modalStyle}>
                        <Formik
                            initialValues={{
                                dropship: null,
                                pengirim: null,
                                penerima: null,
                                alamat: null,
                                kodepos: null,
                                provinsi: null,
                                kota: null,
                                kecamatan: null,
                                telPengirim: telPengirim,
                                telPenerima: telPenerima,
                                kurir: null,
                            }}
                            validate={values => {
                                const errors = {};
                                if (telPengirim === null || telPengirim === '62') {
                                    errors.telPengirim = 'Wajib diisi';
                                }
                                if (telPenerima === null || telPenerima === '62') {
                                    errors.telPenerima = 'Wajib diisi';
                                }
                                if (Object.keys(errors).length > 0) {
                                    window.scrollTo(0, 0);  
                                }
                                return errors;
                            }}
                            onSubmit={async (values, { setSubmitting }) => {

                                values.dropship = isDropship;
                                values.telPengirim = telPengirim;
                                values.telPenerima = telPenerima;
                                values.provinsi = inputProvValue;
                                values.kota = inputCityValue;
                                values.kecamatan = inputSdValue;
                                values.berat = beratPaket;
                                values.invoice = searchParams.get('invoice');
                                values.kurir = selectedCourier;
                                values.layanan = layananState !== null ? layananState.split('|')[0] : null;
                                values.ongkir = layananState !== null ? layananState.split('|')[1] : null;

                                try {
                                    await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/send`,
                                        values,
                                        {
                                            headers: {
                                                Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                            }
                                        }
                                    );
                                    const invoice = searchParams.get('invoice');
                                    const getPengirimanData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/detail-shipping/${searchParams.get('invoice')}`, {
                                        headers: {
                                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    if(getPengirimanData.data.result !== null) {
                                        if (getPengirimanData.data.result.dropship === 'ya') {
                                            if (parseInt(getPengirimanData.data.result.berat) <= 5000 && parseInt(getPengirimanData.data.result.berat) > 0) {
                                                setBiayaDropship(3000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 10000 && parseInt(getPengirimanData.data.result.berat) > 5000) {
                                                setBiayaDropship(5000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 20000 && parseInt(getPengirimanData.data.result.berat) > 10000) {
                                                setBiayaDropship(10000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 30000 && parseInt(getPengirimanData.data.result.berat) > 20000) {
                                                setBiayaDropship(15000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 40000 && parseInt(getPengirimanData.data.result.berat) > 30000) {
                                                setBiayaDropship(20000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 50000 && parseInt(getPengirimanData.data.result.berat) > 40000) {
                                                setBiayaDropship(25000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 60000 && parseInt(getPengirimanData.data.result.berat) > 50000) {
                                                setBiayaDropship(30000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 70000 && parseInt(getPengirimanData.data.result.berat) > 60000) {
                                                setBiayaDropship(35000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 80000 && parseInt(getPengirimanData.data.result.berat) > 70000) {
                                                setBiayaDropship(40000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 90000 && parseInt(getPengirimanData.data.result.berat) > 80000) {
                                                setBiayaDropship(45000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 100000 && parseInt(getPengirimanData.data.result.berat) > 90000) {
                                                setBiayaDropship(50000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 110000 && parseInt(getPengirimanData.data.result.berat) > 100000) {
                                                setBiayaDropship(55000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 120000 && parseInt(getPengirimanData.data.result.berat) > 110000) {
                                                setBiayaDropship(60000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 130000 && parseInt(getPengirimanData.data.result.berat) > 120000) {
                                                setBiayaDropship(65000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 140000 && parseInt(getPengirimanData.data.result.berat) > 130000) {
                                                setBiayaDropship(70000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 150000 && parseInt(getPengirimanData.data.result.berat) > 140000) {
                                                setBiayaDropship(75000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 160000 && parseInt(getPengirimanData.data.result.berat) > 150000) {
                                                setBiayaDropship(80000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 170000 && parseInt(getPengirimanData.data.result.berat) > 160000) {
                                                setBiayaDropship(85000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 180000 && parseInt(getPengirimanData.data.result.berat) > 170000) {
                                                setBiayaDropship(90000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) <= 190000 && parseInt(getPengirimanData.data.result.berat) > 180000) {
                                                setBiayaDropship(95000);
                                            }
                                            if (parseInt(getPengirimanData.data.result.berat) > 190000) {
                                                setBiayaDropship(100000);
                                            }
                                        }
                                        setPengirimanData(getPengirimanData.data.result);
                                    }
                                    setOpenAlert(true);
                                    setAlertStatus('success');
                                    setAlertMessage('Submit pengiriman berhasil');
                                    handleCloseFormAlamat();
                                    navigate(`/dashboard/readystock/detailorder?invoice=${invoice}`);

                                } catch (err) {
                                    console.log(err)
                                    setSubmitting(false);
                                }

                            }}
                        >
                            {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                            }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                    <FormControl>
                                        <RadioGroup
                                        row
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="dropship"
                                        value={isDropship}
                                        onChange={(event) => {
                                            setIsDropship(event.target.value);
                                        }}
                                        >
                                        <FormControlLabel value="ya" control={<Radio required/>} label="Dropship" />
                                        <FormControlLabel value="tidak" control={<Radio required/>} label="Alamat Pribadi" />
                                        </RadioGroup>
                                    </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '16px', fontWeight: 700 }}>
                                            Pengirim
                                        </InputLabel>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            size="small"
                                            required
                                            fullWidth
                                            label="Nama Pengirim"
                                            onChange={handleChange}
                                            name="pengirim"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                            Telepon Pengirim
                                        </InputLabel>
                                        <PhoneInput
                                            disableDropdown
                                            countryCodeEditable={false}
                                            name="telPengirim"
                                            country={'id'}
                                            onlyCountries={['id']}
                                            inputStyle={{ width: '100%', height: '3em' }}
                                            value={telPengirim}
                                            onChange={changeTelPengirim}
                                        />
                                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                            {errors.telPengirim && touched.telPengirim && errors.telPengirim}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '16px', fontWeight: 700 }}>
                                            Penerima
                                        </InputLabel>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            size="small"
                                            required
                                            fullWidth
                                            label="Nama Penerima"
                                            onChange={handleChange}
                                            name="penerima"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                            Telepon Penerima
                                        </InputLabel>
                                        <PhoneInput
                                            required
                                            disableDropdown
                                            countryCodeEditable={false}
                                            name="telPenerima"
                                            country={'id'}
                                            onlyCountries={['id']}
                                            inputStyle={{ width: '100%', height: '3em' }}
                                            value={telPenerima}
                                            onChange={changeTelPenerima}
                                        />
                                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                            {errors.telPenerima && touched.telPenerima && errors.telPenerima}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            required
                                            fullWidth
                                            multiline
                                            rows={3}
                                            label="Alamat Penerima"
                                            onChange={handleChange}
                                            name="alamat"
                                        />
                                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                            {errors.alamat && touched.alamat && errors.alamat}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            size="small"
                                            required
                                            fullWidth
                                            label="Kode Pos"
                                            onChange={handleChange}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                            name="kodepos"
                                        />
                                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                            {errors.kodepos && touched.kodepos && errors.kodepos}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                            Provinsi Tujuan
                                        </InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            value={valueProvince}
                                            onChange={handleSelectProvince}
                                            options={provinces}
                                            getOptionLabel={(option) => option.province_name}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {option.province_name}
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} required />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>                            
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                            Kota/Kabupaten Tujuan
                                        </InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            value={valueCity}
                                            onChange={handleSelectCity}
                                            options={cities}
                                            getOptionLabel={(option) => option.city_name}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {option.city_name}
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} required />}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                            Kecamatan Tujuan
                                        </InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            value={valueSubdistrict}
                                            onChange={handleSelectSubdistrict}
                                            options={subdistricts}
                                            getOptionLabel={(option) => option.subdistrict_name}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {option.subdistrict_name}
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} required />}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                        Berat (Gram)
                                        </InputLabel>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            disabled
                                            size="small"
                                            required
                                            fullWidth
                                            onChange={handleChange}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                            name="berat"
                                            value={beratPaket}
                                        />
                                    </Grid>
                                    {inputProvValue !== null && inputCityValue !== null && inputSdValue !== null && (
                                    <Grid item xs={12}>
                                        <FormControl sx={{ width: '100%' }}>
                                        <InputLabel
                                            id="demo-simple-select-helper-label"
                                            sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                            Kurir
                                        </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="kurir"
                                            label="Kurir"
                                            onChange={(event) => {
                                            setCourier(event.target.value);
                                            setShippingLoading(true);
                                            handleCourirChange(event.target.value);
                                            }}
                                            required
                                        >
                                            <MenuItem value="OR|jne">JNE</MenuItem>
                                            <MenuItem value="OR|tiki">TIKI</MenuItem>
                                            <MenuItem value="OR|pos">POS INDONESIA</MenuItem>
                                            <MenuItem value="OR|wahana">WAHANA</MenuItem>
                                            <MenuItem value="OR|sicepat">SICEPAT</MenuItem>
                                            <MenuItem value='OR|jnt'>J&T</MenuItem>
                                            <MenuItem value='OR|lion'>LION</MenuItem>
                                            <MenuItem value='OR|anteraja'>Anteraja</MenuItem>
                                            <MenuItem value='OR|ide'>ID Express</MenuItem>
                                            {/* <optgroup label="Lainnya (Ongkir Manual)"> */}
                                            <ListSubheader><b>Kurir lainnya (ongkir manual)</b></ListSubheader>
                                            <MenuItem value='OM|idetruck'>&nbsp;&nbsp;ID Express Truck</MenuItem>
                                            <MenuItem value='OM|jntcargo'>&nbsp;&nbsp;J&T Cargo</MenuItem>
                                            <MenuItem value='OM|jtr'>&nbsp;&nbsp;JTR</MenuItem>
                                            <MenuItem value='OM|Ahsan'>&nbsp;&nbsp;Ahsan</MenuItem>
                                            <MenuItem value='OM|Baraka'>&nbsp;&nbsp;Baraka</MenuItem>
                                            <MenuItem value='OM|Dakota'>&nbsp;&nbsp;Dakota</MenuItem>
                                            <MenuItem value='OM|IndahCargo'>&nbsp;&nbsp;IndahCargo</MenuItem>
                                            <MenuItem value='OM|Adam Cargo'>&nbsp;&nbsp;Adam Cargo</MenuItem>
                                            <MenuItem value='OM|Pegasus'>&nbsp;&nbsp;Pegasus</MenuItem>
                                            <MenuItem value='OM|Gosend'>&nbsp;&nbsp;GoSend</MenuItem>
                                            <MenuItem value='OM|KALOG'>&nbsp;&nbsp;KALOG</MenuItem>
                                            <MenuItem value='OM|Sentral'>&nbsp;&nbsp;Sentral</MenuItem>
                                            <MenuItem value='OM|CMC KARGO'>&nbsp;&nbsp;CMC CARGO</MenuItem>
                                            <MenuItem value='OM|Triplogic'>&nbsp;&nbsp;Triplogic</MenuItem>
                                            <MenuItem value='OM|Ambil ke Pusat'>&nbsp;&nbsp;Ambil Ke Pusat</MenuItem>
                                            <MenuItem value='OM|Disatukan'>&nbsp;&nbsp;Disatukan Paket Lainnya</MenuItem>
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    )}
                                    {shippingLoading && (
                                    <Grid item xs={12} align="center">
                                        <Typography variant="body2">Loading ongkir ...</Typography>
                                        <LinearProgress />
                                    </Grid>
                                    )}
                                    {shippingCost && Object.keys(shippingCost).length > 0 && (
                                    <Grid item xs={12}>
                                        <FormControl sx={{ width: '100%' }}>
                                        <InputLabel
                                            id="demo-simple-select-helper-label"
                                            sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                                            Layanan / Ongkir
                                        </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="layanan"
                                            label="Layanan / ongkir"
                                            onChange={(event) => setLayanan(event.target.value)}
                                            required
                                        >
                                            {/* <MenuItem value="tes">tes</MenuItem> */}
                                            {shippingCost.costs.map((item) => (
                                            <MenuItem value={`${item.service}|${item.cost[0].value}`}>{`${item.service} | ${item.cost[0].value}`}</MenuItem>
                                            ))}
                                        </Select>
                                        </FormControl>
                                    </Grid>
                                    )}
                                    <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                    <Button variant="contained" type="submit" disabled={isSubmitting || shippingLoading}>Update</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                        </Formik>
                    </Box>
                </Modal>
                {!confirmingPayment && (
                    <Grid container spacing={2} py={3}>
                        <Snackbar
                            open={openAlert}
                            autoHideDuration={2500}
                            onClose={handleCloseAlert}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            key={'top' + 'center'}
                        >
                            <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                                {alertMessage}
                            </Alert>
                        </Snackbar>
                        <Grid item xs={12} align="center">
                            <Typography variant="h5" fontWeight="700">Detail Order Ready Stock</Typography>
                        </Grid>
                        <Grid item xs={12} align="center">
                            <Typography variant="h6">Invoice #{searchParams.get('invoice')}</Typography>
                        </Grid>
                        <Grid item xs={12} my={1}>
                            <Grid container>
                                <Grid item xs={6} align="left">Status</Grid>
                                <Grid item xs={6} align="left">{orderData && (orderData[0]?.status)}</Grid>
                                
                                <Grid item xs={6} align="left">Payment</Grid>
                                <Grid item xs={6} align="left">{orderData && (orderData[0]?.payment)}</Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} my={1}>
                            <Grid container>
                                <Grid item xs={12} my={1}>
                                    <Typography variant="subtitle1" fontWeight="700">Data pengiriman</Typography>
                                </Grid>
                                <Grid item xs={6} align="left">Dari</Grid>
                                <Grid item xs={6} align="left">{pengirimanData.namapengirim}</Grid>
                                
                                <Grid item xs={6} align="left">Dikirim Ke</Grid><Grid item xs={6} align="left">{pengirimanData.namapenerima}</Grid>
                                <Grid item xs={6} align="left">Alamat</Grid><Grid item xs={6} align="left">{pengirimanData.alamat}</Grid>
                                
                                <Grid item xs={6} align="left">Provinsi</Grid><Grid item xs={6} align="left">{pengirimanData.provinsi}</Grid>
                                <Grid item xs={6} align="left">Kota/Kab</Grid><Grid item xs={6} align="left">{pengirimanData.kota}</Grid>
                                
                                <Grid item xs={6} align="left">Kecamatan</Grid><Grid item xs={6} align="left">{pengirimanData.kecamatan}</Grid>
                                {pengirimanData && pengirimanData.length !== 0 && (
                                    <>
                                        <Grid item xs={6} align="left">Ekspedisi</Grid>
                                        <Grid item xs={6} align="left">
                                            {pengirimanData.ekspedisi === null && (`-`)}
                                            {pengirimanData.ekspedisi !== null && (`${pengirimanData.ekspedisi}`)}
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        {(pengirimanData.length === 0 || pengirimanData === null) && (
                            <Grid item xs={12} my={2} align="center">
                                <Typography variant="caption" color="red" fontWeight="700">
                                    Alamat belum diisi, <br />
                                    silahkan isi alamat&nbsp;
                                    <span
                                        style={{ color: 'blueviolet', cursor: 'pointer' }}
                                        onClick={() => {
                                            const getBerat = async () => {
                                                try {
                                                  const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/berat-paket/${searchParams.get('invoice')}`, {
                                                    headers: {
                                                      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                                    }
                                                  });
                                                  setBerat(cartData.data.result);
                                                } catch (err) {
                                                  console.log(err);
                                                }
                                            };
                                            const getRegion = async () => {
                                                try {
                                      
                                                    const getProvinces = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/province`);
                                                    await setProvinces(getProvinces.data.result);
                                                    const provinceValue = getProvinces.data.result;
                                                    setValueProvince(provinceValue[0]);
                                      
                                                    const getCity = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${provinceValue[0].province_id}`);
                                                    await setCities(getCity.data.result);
                                                    const cityValue = getCity.data.result;
                                                    setValueCity(cityValue[0]);
                                      
                                                    const getSubdistritct = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${cityValue[0].city_id}`);
                                                    await setSubdistricts(getSubdistritct.data.result);
                                                    const subDistrictValue = getSubdistritct.data.result;
                                                    setValueSubdistrict(subDistrictValue[0]);
                                      
                                                } catch (err) {
                                                  console.log(err);
                                                }
                                            };
                                            getBerat();
                                            getRegion();
                                            setOpenFormAlamat(true);
                                        }}
                                    >
                                        disini
                                    </span>
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={12} my={2}>
                            <TableContainer component={Paper} sx={{ maxHeight: {xs: '66vh', sm: 640, md: 768} }}>
                                <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 350 }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">No</TableCell>
                                            <TableCell align="left">QTY</TableCell>
                                            <TableCell align="left">Nama Barang</TableCell>
                                            {/* {new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date && (
                                              <TableCell align="left">Net</TableCell>
                                            )} */}
                                            <TableCell align="left">Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {orderData && orderData.map((row, index) => (
                                            <TableRow
                                                key={row.idorder}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell align="left">{index+1}</TableCell>
                                                <TableCell align="left">{row.jumlah}</TableCell>
                                                <TableCell align="left">{row.namaproduk}</TableCell>
                                                {/* {new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date && (
                                                  <TableCell align="left">
                                                    <s>{(row.subtotal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</s>&nbsp;&nbsp;
                                                    {row.jenis === 'gamis' || row.jenis === 'koko' ? (
                                                      <>
                                                        {(100000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {(50000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                      </>
                                                    )}
                                                  </TableCell>
                                                )} */}
                                                <TableCell align="right">
                                                  {/* {new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date ? (
                                                    <>
                                                      {row.jenis === 'gamis' || row.jenis === 'koko' ? (
                                                        <>
                                                          {(100000 * row.jumlah).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                        </>
                                                      ) : (
                                                        <>
                                                          {(50000 * row.jumlah).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                        </>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {(row.subtotal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                    </>
                                                  )} */}
                                                  {(row.subtotal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                          <TableCell colSpan="3" />
                                          <TableCell align="right">
                                            {/* <s>{(subTotalPaymentNormal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</s>&nbsp; */}
                                            {(subTotalPayment).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(subTotalByJumlah).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                          </TableCell> */}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xs={12} my={1}>
                            {pengirimanData && pengirimanData.length !== 0 && (
                                <Grid container>

                                    {/* {new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date && (
                                      <>
                                        <Grid item xs={6} align="left"><b>Total Harga Normal</b></Grid>
                                        <Grid item xs={6} align="right"><b>Rp {subTotalPaymentNormal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</b></Grid>
                                      </>
                                    )}

                                    {new Date('2024-03-25') <= new Date() && new Date('2024-04-03') >= new Date && (
                                      <>
                                        <Grid item xs={6} align="left">Diskon Flash Sale</Grid>
                                        <Grid item xs={6} align="right">
                                          Rp -{(subTotalPaymentNormal - subTotalByJumlah).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </Grid>
                                      </>
                                    )} */}
                                    

                                    <Grid item xs={6} align="left">{diskonMitraLabel}</Grid>
                                    <Grid item xs={6} align="right">Rp -{diskonMitra.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>

                                    {diskonKategori && diskonKategori.length > 0 && diskonKategori.map((item) => (
                                        <>
                                            <Grid item xs={6} align="left">{item.diskonKategoriLabel}</Grid>
                                            <Grid item xs={6} align="right">
                                                - Rp {item.diskonKategoriValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                            </Grid>
                                        </>
                                    ))}
                                    <Grid item xs={6} align="left">Total Diskon</Grid>
                                    <Grid item xs={6} align="right">
                                      Rp -{(diskonMitra + diskonKategoriTotal + (subTotalPaymentNormal - subTotalByJumlah)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                    </Grid>
                                    <Grid item><br/><br/></Grid>
                                    <Grid item xs={6} align="left"><b>Total Nett</b></Grid>
                                    <Grid item xs={6} align="right">
                                        <b>
                                            {/* if flash sale  */}
                                            {/* Rp {(subTotalPaymentNormal - (diskonMitra + diskonKategoriTotal + (subTotalPaymentNormal - subTotalByJumlah))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} */}
                                            Rp {(subTotalPayment - (diskonMitra + diskonKategoriTotal)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                        </b>
                                    </Grid>

                                    <Grid item xs={6} align="left">Estimasi Ongkir</Grid>
                                    <Grid item xs={6} align="right">
                                        {pengirimanData.ongkir === null && (`Menunggu diisi admin`)}
                                        {pengirimanData.ongkir !== null && (`Rp ${pengirimanData.ongkir?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`)}
                                    </Grid>

                                    <Grid item xs={6} align="left">Biaya Dropship</Grid>
                                    <Grid item xs={6} align="right">Rp {biayaDropship.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>

                                    <Grid item xs={6} align="left"><b>Total Bayar</b></Grid>
                                    <Grid item xs={6} align="right">
                                        {/* if flash sale */}
                                        {/* <b>Rp {((subTotalPaymentNormal - (diskonMitra + diskonKategoriTotal + (subTotalPaymentNormal - subTotalByJumlah))) + biayaDropship + pengirimanData.ongkir).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</b> */}
                                        <b>Rp {((subTotalPayment - (diskonMitra + diskonKategoriTotal)) + biayaDropship + pengirimanData.ongkir).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</b>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                        {(orderData[0]?.status === 'Proses' || orderData[0]?.status === 'Selesai') && (
                            <Grid item xs={12} align="center">
                                <Typography
                                    variant="h6"
                                    sx={{ padding: 1, border: 'dashed 2px #9abecb', backgroundColor: '#f4fcff' }}
                                >
                                    Sudah konfirmasi pembayaran
                                </Typography>
                            </Grid>
                        )}
                        {(orderData[0]?.status === 'Tunggu Confirm Admin') && (
                            <Grid item xs={12} align="center">
                                <Typography
                                    variant="h6"
                                    sx={{ padding: 1, border: 'dashed 2px #e96811', backgroundColor: '#fff4e9' }}
                                >
                                    Menunggu konfirmasi admin
                                </Typography>
                            </Grid>
                        )}
                        {Date.parse(new Date().toISOString().split('T')[0]) < Date.parse(pengirimanData.expired) &&
                            orderData[0]?.status === 'Pending' && (
                            <Grid item xs={12} align="center">
                                <Typography variant="subtitle1" fontWeight="700" sx={{ color: '#4a7dbd' }}>
                                    Batas waktu pembayaran
                                </Typography>
                            </Grid>  
                        )}
                        {orderData[0]?.status === 'Pending' && pengirimanData.length !== 0 && (
                            <>
                                <Grid item xs={12} align="center">
                                    <Typography variant="subtitle1">
                                        <Countdown date={new Date(pengirimanData.expired)} renderer={renderer} />
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} align="center">
                                    <Button variant="contained" onClick={() => setConfirming(true)}>Konfirmasi Pembayaran</Button>
                                </Grid>
                            </>
                        )}
                    </Grid>
                )}

                {confirmingPayment && (
                    <Grid container spacing={2}>
                        <Snackbar
                            open={openAlert}
                            autoHideDuration={2500}
                            onClose={handleCloseAlert}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            key={'top' + 'center'}
                        >
                            <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                                {alertMessage}
                            </Alert>
                        </Snackbar>
                        <Grid item xs={12} align="center">
                            <Typography variant="h5" fontWeight="700">Konfirmasi Pembayaran</Typography>
                        </Grid>
                        <Grid item xs={12} align="center">
                            <Typography variant="h6" style={{ color: '#5a5a5a' }}>Invoice #{pengirimanData.invoice}</Typography>
                        </Grid>
                        <Grid item xs={12} align="center">
                            <Typography variant="subtitle1" fontWeight="700" style={{ color: '#5a5a5a' }}>
                                Rp {(subTotalPayment + biayaDropship - diskonMitra - diskonKategoriTotal + pengirimanData.ongkir).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl>
                                <FormLabel id="demo-radio-buttons-group-label">Jenis Pembayaran</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="female"
                                    name="radio-buttons-group"
                                >
                                    {authData.role === 'distributor' && (
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    value={1}
                                                    onChange={() => {
                                                        setBankPayment(false);
                                                        setEscrowPayment(true);
                                                        setMixPayment(false);
                                                        setTotalPayment(subTotalPayment + biayaDropship - diskonMitra - diskonKategoriTotal + pengirimanData.ongkir);
                                                    }}
                                                />
                                            }
                                            label="Ambil dari saldo"
                                        />
                                    )}
                                    <FormControlLabel
                                        control={
                                            <Radio
                                                value={2}
                                                onChange={() => {
                                                    setBankPayment(true);
                                                    setJmlhtransfer(subTotalPayment + biayaDropship - diskonMitra - diskonKategoriTotal + pengirimanData.ongkir);
                                                    setEscrowPayment(false);
                                                    setMixPayment(false);
                                                    setTotalPayment(subTotalPayment + biayaDropship - diskonMitra - diskonKategoriTotal + pengirimanData.ongkir);
                                                }}
                                            />
                                        }
                                        label="Transfer Bank"
                                    />
                                    {authData.role === 'distributor' && (
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    value={3}
                                                    onChange={() => {
                                                        setBankPayment(false);
                                                        setEscrowPayment(false);
                                                        setMixPayment(true);
                                                        setTotalPayment(subTotalPayment + biayaDropship - diskonMitra - diskonKategoriTotal + pengirimanData.ongkir);
                                                    }}
                                                />
                                            }
                                            label="Ambil saldo + Transfer Bank"
                                        />
                                    )}
                                </RadioGroup>
                            </FormControl>
                            <Divider />
                        </Grid>
                        {bankPayment && (
                            <Grid item xs={12} my={1} px={2}>
                                <Formik
                                    initialValues={{
                                        rekening: rekeningFrom,
                                        jumlah: null,
                                        rekeningTujuan: rekeningTo
                                    }}
                                    validate={values => {
                                        const errors = {};
                                        return errors;
                                    }}
                                    onSubmit={async (values, { setSubmitting }) => {
                                        const builtVal = {
                                            metode: 'bank',
                                            invoice: searchParams.get('invoice'),
                                            bankpengirim: rekeningFrom.bank,
                                            rekeningpengirim: `${rekeningFrom.namapemilik} / ${rekeningFrom.rekening}`,
                                            jmlhtransfer,
                                            metodebayar: rekeningTo,
                                            totalBayar: totalPayment,
                                            foto: selectedFile
                                        };

                                        try {
                                            await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/payment-confirm`,
                                                builtVal,
                                                {
                                                    headers: {
                                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                                                        "Content-Type": "multipart/form-data"
                                                    }
                                                }
                                            );
                                            setOpenAlert(true);
                                            setAlertStatus('success');
                                            setAlertMessage('Konfirmasi pembayaran berhasil');
                                            localStorage.removeItem('invoicePengiriman');
                                            setConfirming(false);
                                            getRekeningku();
                                            getSaldo();
                                            getOrder();
                                            getPengiriman();
                                            navigate(`/dashboard/readystock/detailorder?invoice=${searchParams.get('invoice')}`);
                                            location.reload();

                                        } catch (err) {
                                        
                                            console.log(err)
                                            setSubmitting(false);

                                        }

                                    }}
                                >
                                    {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                    /* and other goodies */
                                    }) => (
                                        <form onSubmit={handleSubmit}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} my={1} align="center">
                                                    <Typography variant="subtitle1" fontWeight="700">Pembayaran dari transfer bank</Typography>
                                                </Grid>
                                                <Grid item xs={12} align="left">
                                                    <FormControl sx={{ width: '100%' }}>
                                                        {rekeningku.length > 0 ? (
                                                            <>
                                                                <InputLabel
                                                                    id="demo-simple-select-helper-label"
                                                                    sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}
                                                                >
                                                                    Rekening Pengirim
                                                                </InputLabel>
                                                                <Select
                                                                    fullWidth
                                                                    labelId="demo-simple-select-label"
                                                                    id="demo-simple-select"
                                                                    name="rekening"
                                                                    label="Rekening Pengirim"
                                                                    onChange={(event) => {
                                                                        setRekeningFrom(event.target.value);
                                                                    }}
                                                                    required
                                                                >
                                                                    {rekeningku && rekeningku.map((item) => (
                                                                        <MenuItem
                                                                            value={item}
                                                                        >
                                                                            {`${item.bank} | ${item.rekening} | ${item.namapemilik}`}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </>
                                                        ) : (
                                                            <Alert
                                                                severity="warning"
                                                                action={
                                                                    <Button
                                                                        variant="contained"
                                                                        size="small"
                                                                        color="primary"
                                                                        onClick={() => handleOpenModalRekening(true)}
                                                                    >
                                                                        +tambah
                                                                    </Button>
                                                                }
                                                            >
                                                                Data rekening belum ditambahkan.
                                                            </Alert>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} align="left">
                                                    <TextField
                                                        id="outlined-multiline-flexible"
                                                        size="small"
                                                        required
                                                        fullWidth
                                                        label="Jumlah Transfer"
                                                        onChange={(event) => {
                                                            setJmlhtransfer(event.target.value);
                                                        }}
                                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                                        name="jumlah"
                                                        value={jmlhtransfer}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} align="left">
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <InputLabel
                                                            id="demo-simple-select-helper-label"
                                                            sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}
                                                        >
                                                            Metode Pembayaran
                                                        </InputLabel>
                                                        <Select
                                                            fullWidth
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            name="rekeningtujuan"
                                                            label="Metode Pembayaran"
                                                            onChange={(event) => {
                                                                setRekeningTo(event.target.value);
                                                            }}
                                                            required
                                                        >
                                                            <MenuItem value="Mandiri 1300017715213">Mandiri 1300017715213</MenuItem>
                                                            <MenuItem value="Muamalat 1100003930">Muamalat 1100003930</MenuItem>
                                                            <MenuItem value="Bank Syariah Indonesia (BSI) 7105696706">Bank Syariah Indonesia (BSI) 7105696706</MenuItem>
                                                            <MenuItem value="BRI 114101014094501">BRI 114101014094501</MenuItem>
                                                            <MenuItem value="BCA 2230917275">BCA 2230917275</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} align="left">
                                                    <TextField
                                                        required
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(event) => {
                                                            setSelectedFile(event.target.files[0]);
                                                        }}
                                                        name="foto"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sx={{ textAlign: 'center', padding: '10px 0px' }}>
                                                    <Button variant="contained" type="submit" disabled={isSubmitting || rekeningku.length === 0}>
                                                        Kirim
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    )}
                                </Formik>
                            </Grid>
                        )}
                        {escrowPayment && authData.role === 'distributor' && (
                            <Grid item xs={12} my={1}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} my={1} align="center">
                                        <Typography variant="subtitle1" fontWeight="700">Pembayaran dari saldo</Typography>
                                    </Grid>
                                    <Grid item xs={6} align="left">Total Tagihan</Grid>
                                    <Grid item xs={6} align="left">Rp {totalPayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>

                                    <Grid item xs={6} align="left">Saldo saat ini</Grid>
                                    <Grid item xs={6} align="left">Rp {saldoData}</Grid>
                                    
                                    <Grid item xs={12}><Divider /></Grid>
                                    {saldoData >= totalPayment && (
                                        <Grid item xs={12} align="center">
                                            <Button
                                                variant="contained"
                                                onClick={async () => {
                                                    const builtVal = {
                                                        metode: 'escrow',
                                                        invoice: searchParams.get('invoice'),
                                                        jmlhtransfer: totalPayment,
                                                        totalBayar: totalPayment
                                                    };
        
                                                    try {
                                                        await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/payment-confirm`,
                                                            builtVal,
                                                            {
                                                                headers: {
                                                                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                                                }
                                                            }
                                                        );
                                                        setOpenAlert(true);
                                                        setAlertStatus('success');
                                                        setAlertMessage('Konfirmasi pembayaran berhasil');
                                                        localStorage.removeItem('invoicePengiriman');
                                                        setConfirming(false);
                                                        getRekeningku();
                                                        getSaldo();
                                                        getOrder();
                                                        getPengiriman();
                                                        navigate(`/dashboard/readystock/detailorder?invoice=${searchParams.get('invoice')}`)
        
                                                    } catch (err) {
                                                    
                                                        console.log(err)
                                                        setSubmitting(false);
        
                                                    }
                                                }}
                                            >
                                                Kirim
                                            </Button>
                                        </Grid>
                                    )}
                                    {saldoData < totalPayment && (
                                        <Grid item xs={12} align="center">
                                            <span style={{ color: '#ab2323', fontWeight: '700', border: '1px solid rgb(233 140 140)', backgroundColor: '#ffd8d8', padding: '10px' }}>
                                                Saldo kurang dari total tagihan
                                            </span>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                        
                        {mixPayment && authData.role === 'distributor' && (
                            <Grid item xs={12} my={1} px={2}>
                                {saldoData >= totalPayment && (
                                    <Formik
                                        initialValues={{
                                            rekening: rekeningFrom,
                                            jumlah: null,
                                            rekeningTujuan: rekeningTo

                                        }}
                                        validate={values => {
                                            const errors = {};
                                            return errors;
                                        }}
                                        onSubmit={async (values, { setSubmitting }) => {
                                            const builtVal = {
                                                metode: 'mix',
                                                invoice: searchParams.get('invoice'),
                                                bankpengirim: mixRekeningFrom.bank,
                                                rekeningpengirim: `${mixRekeningFrom.namapemilik} / ${mixRekeningFrom.rekening}`,
                                                jmlhfrombank: mixJmlhtransfer,
                                                metodebayar: mixRekeningTo,
                                                jmlhfromsaldo: mixPakaiSaldo,
                                                totalBayar: totalPayment
                                            };

                                            try {
                                                await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/shipping/payment-confirm`,
                                                    builtVal,
                                                    {
                                                        headers: {
                                                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                                        }
                                                    }
                                                );
                                                setOpenAlert(true);
                                                setAlertStatus('success');
                                                setAlertMessage('Konfirmasi pembayaran berhasil');
                                                localStorage.removeItem('invoicePengiriman');
                                                setConfirming(false);
                                                getRekeningku();
                                                getSaldo();
                                                getOrder();
                                                getPengiriman();
                                                navigate(`/dashboard/readystock/detailorder?invoice=${searchParams.get('invoice')}`)

                                            } catch (err) {
                                                console.log(err)
                                                setSubmitting(false);
                                            }

                                        }}
                                    >
                                        {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        /* and other goodies */
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} my={1} align="center">
                                                        <Typography variant="subtitle1" fontWeight="700">Pembayaran dari transfer bank</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} align="left">
                                                        <FormControl sx={{ width: '100%' }}>
                                                            <InputLabel
                                                                id="demo-simple-select-helper-label"
                                                                sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}
                                                            >
                                                                Rekening Pengirim
                                                            </InputLabel>
                                                            <Select
                                                                fullWidth
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                name="rekening"
                                                                label="Rekening Pengirim"
                                                                onChange={(event) => {
                                                                    setMixRekeningFrom(event.target.value);
                                                                }}
                                                                required
                                                            >
                                                                {rekeningku && rekeningku.map((item) => (
                                                                    <MenuItem
                                                                        value={item}
                                                                    >
                                                                        {`${item.bank} | ${item.rekening} | ${item.namapemilik}`}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} align="left">
                                                        <TextField
                                                            id="outlined-multiline-flexible"
                                                            size="small"
                                                            required
                                                            fullWidth
                                                            label="Jumlah Transfer"
                                                            onChange={(event) => {
                                                                setMixJmlhtransfer(event.target.value);
                                                                setMixPakaiSaldo(totalPayment - event.target.value);
                                                            }}
                                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                                            name="mixJmlhtransfer"
                                                            value={mixJmlhtransfer}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} align="left">
                                                        <FormControl sx={{ width: '100%' }}>
                                                            <InputLabel
                                                                id="demo-simple-select-helper-label"
                                                                sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}
                                                            >
                                                                Metode Pembayaran
                                                            </InputLabel>
                                                            <Select
                                                                fullWidth
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                name="mixRekeningTo"
                                                                label="Metode Pembayaran"
                                                                onChange={(event) => {
                                                                    setMixRekeningTo(event.target.value);
                                                                }}
                                                                required
                                                            >
                                                                <MenuItem value="Mandiri 1300017715213">Mandiri 1300017715213</MenuItem>
                                                                <MenuItem value="Muamalat 1100003930">Muamalat 1100003930</MenuItem>
                                                                <MenuItem value="Bank Syariah Indonesia (BSI) 7105696706">Bank Syariah Indonesia (BSI) 7105696706</MenuItem>
                                                                <MenuItem value="BRI 076201007469504">BRI 076201007469504</MenuItem>
                                                                <MenuItem value="BCA 7751043434">BCA 7751043434</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} my={1}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} my={1} align="center">
                                                                <Typography variant="subtitle1" fontWeight="700">Pembayaran dari Saldo</Typography>
                                                            </Grid>
                                                            
                                                            <Grid item xs={6} align="left">Saldo saat ini</Grid>
                                                            <Grid item xs={6} align="left">Rp {saldoData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>

                                                            <Grid item xs={6} align="left">Saldo akan dipakai</Grid>

                                                            <Grid item xs={6} align="left">
                                                                <TextField
                                                                    id="outlined-multiline-flexible"
                                                                    size="small"
                                                                    required
                                                                    fullWidth
                                                                    onChange={(event) => {
                                                                        setMixPakaiSaldo(event.target.value);
                                                                        setMixJmlhtransfer(totalPayment - event.target.value);
                                                                    }}
                                                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                                                    name="mixsaldo"
                                                                    value={mixPakaiSaldo}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}><Divider /></Grid>
                                                            
                                                            <Grid item xs={12} my={1} align="center">
                                                                <Typography variant="subtitle1" fontWeight="700">Pembayaran Saldo + Transfer Bank</Typography>
                                                            </Grid>

                                                            <Grid item xs={6} align="left">Jumlah Tagihan</Grid>
                                                                <Grid item xs={6} align="right">Rp {totalPayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>

                                                            <Grid item xs={6} align="left">Jumlah pembayaran saldo</Grid>
                                                                <Grid item xs={6} align="right">Rp {mixPakaiSaldo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>

                                                            <Grid item xs={6} align="left">Jumlah pembayaran bank</Grid>
                                                                <Grid item xs={6} align="right">Rp {mixJmlhtransfer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</Grid>
                                                            
                                                            <Grid item xs={12} align="center">                                            
                                                                <Button variant="contained" type="submit" disabled={isSubmitting}>Kirim</Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        )}
                                    </Formik>
                                )}
                                {saldoData < totalPayment && (
                                    <Grid item xs={12} align="center">
                                        <Typography style={{ color: '#ab2323', fontWeight: '700', border: '1px solid rgb(233 140 140)', backgroundColor: '#ffd8d8', padding: '10px' }}>
                                            Saldo kurang dari total tagihan, silahkan gunakan transfer bank
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        )}     
                    </Grid>
                )}
                <FooterNavReadyStock />
                <Modal
                    open={openModalRekening}
                    onClose={handleCloseModalRekening}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={modalStyle}>
                        <Formik
                            initialValues={{ bank: null, namapemilik: null, rekening: null }}
                            validate={values => {
                                const errors = {};
                                if (!values.bank) {
                                    errors.bank = 'Wajib diisi';
                                }
                                if (!values.namapemilik) {
                                    errors.namapemilik = 'Wajib diisi';
                                }
                                if (!values.rekening) {
                                    errors.rekening = 'Wajib diisi';
                                }
                                return errors;
                            }}
                            onSubmit={async (values, { setSubmitting }) => {
                                try {
                                    await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/rekeningku`, values, {
                                        headers: {
                                            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    // update states
                                    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/rekeningku`, {
                                        headers: {
                                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                                        }
                                    });
                                    setOpenAlert(true);
                                    setRekeningku(res.data.result);
                                    setAlertStatus('success');
                                    setAlertMessage('Tambah rekening berhasil');
                                    handleCloseModalRekening();
                                } catch (err) {
                                    console.log(err);
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                            }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                        <Typography id="modal-modal-title" variant="subtitle1" fontWeight="700">
                                            Tambah Rekening
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            required
                                            fullWidth
                                            label="Nama Bank"
                                            onChange={handleChange}
                                            name="bank"
                                        />
                                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                            {errors.bank && touched.bank && errors.bank}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            required
                                            fullWidth
                                            label="Nama Pemilik"
                                            onChange={handleChange}
                                            name="namapemilik"
                                        />
                                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                            {errors.namapemilik && touched.namapemilik && errors.namapemilik}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="outlined-multiline-flexible"
                                            required
                                            fullWidth
                                            label="Nomor Rekening"
                                            onChange={handleChange}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', type: 'number' }}
                                            name="rekening"
                                        />
                                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                                            {errors.rekening && touched.rekening && errors.rekening}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                                        <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                                    </Grid>
                                </Grid>
                            </form>
                            )}
                        </Formik>
                    </Box>
                </Modal>
            </Container>
        </div>
    )
}

export default ReadyStockOrdered
